import { render, staticRenderFns } from "./InformationCollapse.vue?vue&type=template&id=741bb27a"
import script from "./InformationCollapse.vue?vue&type=script&lang=js"
export * from "./InformationCollapse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports